import React, { Fragment } from 'react'
import { UncontrolledTooltip } from 'reactstrap'
import { useNavigate } from 'react-router-dom'
import { DefaultConfig } from '../../settings/config'

export const veselListColumns = (functionCall) => {
  const formattedDateIssueFixed = DefaultConfig().formattedDateIssueFixed
  const columns = [
    {
      name: 'id',
      sortName: 'id',
      sortable: true,
      cell: (row) => (
        <div style={{ cursor: 'pointer' }} onClick={() => { functionCall(row) }}>
          {row.id}
        </div>
      ),
      sortable: true
    },
    {
      name: 'vesselId',
      sortName: 'vesselId',
      sortable: true,
      cell: (row) => (
        <div style={{ cursor: 'pointer' }} onClick={() => { functionCall(row) }}>
          {row.vesselId}
        </div>
      ),
      sortName: 'vesselId',
      sortable: true
    },
    {
      name: ' Name',
      cell: (row) => {
        const targetId = `name-${row.id}`
        return (
          <Fragment>
            <div onClick={() => { functionCall(row) }} style={{ whiteSpace: 'normal', wordBreak: 'break-word', cursor: 'pointer' }} id={targetId} className='rlmlinkshyperBlack'>
              {row.name || '-'}
            </div>
            <UncontrolledTooltip placement='bottom' target={targetId}>
              {row.name || '-'}
            </UncontrolledTooltip>
          </Fragment>
        )
      },
      sortName: 'name',
      sortable: true
    },
    {
      name: 'imonumber',
      cell: (row) => {
        const targetId = `imonumber-${row.id}`
        return (
          <Fragment>
            <div onClick={() => { functionCall(row) }} style={{ whiteSpace: 'normal', wordBreak: 'break-word', cursor: 'pointer', color: "#000 !important" }} id={targetId} className='rlmlinkshyperBlack'>
              {row.imonumber || '-'}
            </div>
            <UncontrolledTooltip placement='bottom' target={targetId}>
              {row.imonumber || '-'}
            </UncontrolledTooltip>
          </Fragment>
        )
      },
      sortName: 'imonumber',
      sortable: true
    },
    {
      name: 'officialNumber',
      cell: (row) => {
        const targetId = `email-${row.id}`
        return (
          <Fragment>
            <div onClick={() => { functionCall(row) }} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }} id={targetId}
              className='rlmlinkshyperBlack'>
              {row.officialNumber || '-'}
            </div>
            <UncontrolledTooltip placement='bottom' target={targetId}>
              {row.officialNumber || '-'}
            </UncontrolledTooltip>
          </Fragment>
        )
      },
      sortName: 'officialNumber',
      sortable: true
    },
    {
      name: 'Status',
      cell: (row) => {
        const targetId = `status-${row.id}`
        const options = ["Active", "Inactive", "Suspended"]
        return (
          <Fragment>
            <div onClick={() => { functionCall(row) }} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }} id={targetId}>
              {row.status ? options[row.status - 1] : '-'}
            </div>
            <UncontrolledTooltip placement='bottom' target={targetId}>
              {row.status ? options[row.status - 1] : '-'}
            </UncontrolledTooltip>
          </Fragment>
        )
      },
      sortName: 'status',
      sortable: true
    }
  ]


  return columns
}
// export const ActiveCompanies = (functionCall) => {
//     const regionalOffices = DefaultConfig().regionalOffices
//     const DepartmentMapping = DefaultConfig().DepartmentMapping
//     const formattedDateIssueFixed = DefaultConfig().formattedDateIssueFixed
//     const columns = [
//         {
//             name: <div>Company ID</div>,
//             width: "9%",
//             sortName: "Id",
//             sortable: true,
//             cell: (row) => (
//                 <div style={{ cursor: 'pointer' }} onClick={() => { functionCall(row) }}>
//                     {row.id}
//                 </div>
//             )
//         },

//         {
//             name: <div>Agent ID</div>,
//             width: "8%",
//             selector: row => {
//                 const targetId = `lastName-${row.id}`
//                 return (
//                     <Fragment>
//                         <div onClick={() => { functionCall(row) }} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }} id={targetId}
//                             className='rlmlinkshyperBlack'> {row.agentId ? row.agentId : '-'}</div>
//                         <UncontrolledTooltip placement='bottom' target={targetId}>
//                             {row.agentId ? row.agentId : '-'}
//                         </UncontrolledTooltip>
//                     </Fragment>
//                 )
//             },
//             sortName: "agentId",
//             sortable: true
//         },
//         {
//             name: <div>Company Name</div>,
//             width: "25%",
//             selector: row => {
//                 const targetId = `Name-${row.id}`
//                 return (
//                     <Fragment>
//                         <div onClick={() => { functionCall(row) }} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }} id={targetId} className='rlmlinkshyperBlack'> {row.name ? row.name : '-'}</div>
//                         <UncontrolledTooltip placement='bottom' target={targetId}>
//                             {row.name ? row.name : '-'}
//                         </UncontrolledTooltip>
//                     </Fragment>
//                 )
//             },
//             sortName: "name",
//             sortable: true
//         },
//         {
//             name: <div>SF Unique ID</div>,
//             width: "9%",
//             selector: row => {
//                 const targetId = `email-${row.id}`
//                 return (
//                     <Fragment>
//                         <div onClick={() => { functionCall(row) }} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }} id={targetId} className='rlmlinkshyperBlack'> {row.sfUniqueId ? row.sfUniqueId : ''}</div>
//                         <UncontrolledTooltip placement='bottom' target={targetId}>
//                             {row.sfUniqueId ? row.sfUniqueId : ''}
//                         </UncontrolledTooltip>
//                     </Fragment>
//                 )
//             },
//             sortName: "sfUniqueId",
//             sortable: true
//         },
//         {
//             name: <div>Regional Office</div>,
//             width: "15%",
//             selector: row => {
//                 const targetId = `email2-${row.id}`
//                 return (
//                     <Fragment>
//                         <div onClick={() => { functionCall(row) }} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }} id={targetId} className='rlmlinkshyperBlack'> {row.regionalOfficeId ? regionalOffices.find((item) => item.id === row.regionalOfficeId)?.label : ''}</div>
//                         <UncontrolledTooltip placement='bottom' target={targetId}>
//                             {row.regionalOfficeId ? regionalOffices.find((item) => item.id === row.regionalOfficeId)?.label : '-'}
//                         </UncontrolledTooltip>
//                     </Fragment>
//                 )
//             },
//             sortName: "sfUniqueId",
//             sortable: true
//         },
//         {
//             name: <div>GP Client Department</div>,
//             width: "15%",
//             selector: row => {
//                 const targetId = `email1-${row.id}`
//                 return (
//                     <Fragment>
//                         <div onClick={() => { functionCall(row) }} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }} id={targetId} className='rlmlinkshyperBlack'> {row.gpClientDepartmentId ? DepartmentMapping().find((item) => item.id === row.gpClientDepartmentId)?.label : '-'}</div>

//                         <UncontrolledTooltip placement='bottom' target={targetId}>
//                             {row.gpClientDepartmentId ? DepartmentMapping().find((item) => item.id === row.gpClientDepartmentId)?.label : '-'}
//                         </UncontrolledTooltip>
//                     </Fragment>
//                 )
//             },
//             sortName: "gpClientDepartmentId",
//             sortable: true
//         },
//         {
//             name: <div>Created Date</div>,
//             width: "9%",
//             selector: row => {
//                 const targetId = `email4-${row.id}`
//                 return (
//                     <Fragment>
//                         <div onClick={() => { functionCall(row) }} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }} id={targetId} className='rlmlinkshyperBlack'>  {row.createdDate ? formattedDateIssueFixed(row.createdDate) : "-"}</div>

//                         <UncontrolledTooltip placement='bottom' target={targetId}>
//                             {row.createdDate ? formattedDateIssueFixed(row.createdDate) : ""}
//                         </UncontrolledTooltip>
//                     </Fragment>
//                 )
//             },
//             sortName: "createdDate",
//             sortable: true
//         },
//         {
//             name: 'Status',
//             width: "10%",
//             selector: row => {
//                 const targetId = `status-${row.id}`
//                 const options = ["Active", "Inactive", "Suspended"]
//                 return (
//                     <Fragment>
//                         <div onClick={() => { functionCall(row) }} style={{ whiteSpace: 'normal', wordBreak: 'break-word' }} id={targetId} > {row.status ? options[row.status - 1] : ''}</div>
//                         {/* <UncontrolledTooltip placement='bottom' target={targetId}>
//                             {row.status ? row.status : '-'}
//                         </UncontrolledTooltip> */}
//                         <UncontrolledTooltip placement='bottom' target={targetId}>
//                             {row.status ? options[row.status - 1] : ''}
//                         </UncontrolledTooltip>
//                     </Fragment>
//                 )
//             },
//             sortName: "status",
//             sortable: true
//         }
//     ]
//     return columns
// }